import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import { Paper, withStyles } from '@material-ui/core';
import ChassisTypeForm, {systemTypes} from './ChassisTypeForm'
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/chassisTypeActions";
import History from "../../../History";
import { types } from '../../sc-utilities/ChassisType';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }

});

const ChassisTypeCreate = props => {
    const { permissions, activeCustomer, translations, classes, onCreateChassisType, onFetchChassisTypeValues } = props;
    const [typeValues, setTypeValues] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            let typeValueData = await onFetchChassisTypeValues({ ActiveCustomerID: activeCustomer });
            setTypeValues(typeValueData);
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // The backend list wins for what is OFFERED; the constant list bridges the fetch and an empty
    // answer. What is SELECTED cannot come from the fetch: initialValues feeds a form with
    // enableReinitialize, so a value that changes when the request lands resets the form under the
    // operator - losing a TypeKey typed in the meantime. The default is therefore fixed at mount,
    // and the option list carries it even if the backend no longer offers it, exactly as the edit
    // screen does for a saved row.
    const chassisTypeValues = typeValues.length ? typeValues : types;
    const defaultTypeValue = types.length > 0 ? types[0].value : '';
    const typeOptions = defaultTypeValue && !chassisTypeValues.some(option => option.value === defaultTypeValue)
        ? [...chassisTypeValues, { value: defaultTypeValue, displayValue: defaultTypeValue }]
        : chassisTypeValues;

    const handleSubmit = async data => {
        let objestToSend = {...data};
        if (objestToSend["Key"] === "" || objestToSend["CustomerID"] === 'custom') {
            objestToSend["Key"] = null;
        }
        objestToSend["CustomerID"] === "system" ? objestToSend["CustomerID"] = null    :   objestToSend["CustomerID"] = activeCustomer;
        let result = await onCreateChassisType({ ...objestToSend, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        TypeKey: "",
        TypeValue: defaultTypeValue,
        CustomerID: systemTypes && systemTypes.length > 0 ? systemTypes[0].value : '',
        Key: '',
    };

    let formSettings = {
        Validation: {
            TypeKey: Yup.string().required("Required"),
            TypeValue: Yup.string().required("Required"),
            CustomerID: Yup.string().required("Required"),
            Key: Yup.string().required("Required"),
        },
        FormTitle: translations['create_chassis_type'] || 'Create chassis type',
        ButtonSubmit: hasPermission(permissions, "chassis_type_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <ChassisTypeForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                types={typeOptions}
                translations={translations}
                permissions={permissions}
                CustomerIDPreviousState={''}
            />
        </Paper>
    )
}
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateChassisType: chassisType => dispatch(actions.createChassisType(chassisType)),
        onFetchChassisTypeValues: params => dispatch(actions.fetchChassisTypeValues(params))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ChassisTypeCreate));
